export default __webpack_public_path__ + "static/media/companies_gray_3.bd21a36e.png";